import { createRequestTypes } from 'appUtils';

export const FETCH_PREDICTION_HOURS = createRequestTypes(
  'FETCH_PREDICTION_HOURS'
);
